<script setup lang="ts">
import { computed } from 'vue'
import type { Voucher } from '@nsftx/seven-client-retail-vue-sgp'
import SSDetailsTable from '@/ui/components/common/SSDetailsTable.vue'
import type { DetailsTableColumn } from '@/types/SSDetailsTableProps'
import { formatNumber } from '@nsftx/seven-nxg-retail-vue-sdk'
import { formatDateTimeToLocaleString } from '@/utils/dateTimeHelpers'

const props = defineProps<{
  voucher: Voucher
}>()

const columns: DetailsTableColumn[] = [
  { key: 'amount', labelKey: 'voucher_details_header_amount' },
  { key: 'validUntil', labelKey: 'voucher_details_header_valid_until' },
  { key: 'issuedIn', labelKey: 'voucher_details_header_issued_in' },
  { key: 'redeemedAt', labelKey: 'voucher_details_header_redeemed_at' },
  { key: 'redeemedIn', labelKey: 'voucher_details_header_redeemed_in' },
]

const rows = computed(() => [
  {
    amount: formatNumber(props.voucher.context.amount, {
      style: 'currency',
      currencySymbol: props.voucher.context.currency,
    }),
    validUntil: formatDateTimeToLocaleString(props.voucher.context.validUntil),
    issuedIn: props.voucher.context.issuedIn,
    redeemedAt: props.voucher?.activity?.usedAt
      ? formatDateTimeToLocaleString(props.voucher?.activity?.usedAt)
      : '-',
    redeemedIn: props.voucher?.activity?.usedIn
      ? `${props.voucher?.activity?.usedIn?.locationName}`
      : '-',
  },
])
</script>

<template>
  <SSDetailsTable :columns="columns" :rows="rows" />
</template>
